module.exports = __webpack_public_path__ + "img/upload-white.52788c7f.svg";